import { Component, OnInit } from '@angular/core';

import {
  ClosableModalWithErrorResponseModel
} from '../../shared/components/base/closable-modal-with-error-response-model';

import { NotificationService, UtilsService } from '../../shared/services';
import { ModalService } from '../../shared/modules/modal';
import { TransactionsMethodEvaluationService } from '../../shared/services/transaction-method-evaluation.service';
import {
  MethodEvaluation,
  TransactionMethodEvaluationModalPayload,
  MethodEvaluationErrorResponse,
  PliValueType,
  EnumValueSet
} from '../../shared/models';

import { TinyTextEditor } from '../../shared/constants';

@Component({
  selector: 'transaction-method-evaluation-modal',
  templateUrl: './transaction-method-evaluation-modal.component.html',
})
export class TransactionMethodEvaluationModalComponent
  extends ClosableModalWithErrorResponseModel<MethodEvaluationErrorResponse>
  implements OnInit {

  data: TransactionMethodEvaluationModalPayload;
  srcJurisdictionMethodEvaluations: EnumValueSet[];
  destJurisdictionMethodEvaluations: EnumValueSet[];
  evaluation: MethodEvaluation = new MethodEvaluation();

  tinyInit = TinyTextEditor.INIT;

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    private _utilsService: UtilsService,
    private _methodEvaluationService: TransactionsMethodEvaluationService
  ) {
    super(notificationService, modalService);
  }

  ngOnInit(): void {
    this.evaluation = this._utilsService.jsonClone(this.data.methodEvaluation);
    this.setEvaluationOfMethodTypesDropdownValues();
    this.listenForErrorMessages();
  }

  shouldUseUSAMethodEvaluation(jurisdictionIsoCode: string): boolean {
    return this._methodEvaluationService.shouldUseUSAMethodEvaluation(jurisdictionIsoCode);
  }

  save(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;
    this.evaluation.compSearchId = this.data.compSearchId;

    if (this.data.isPba) {
      this.evaluation.pliValueType = new PliValueType();
      this.evaluation.pliValueType.pliValueTypeId = this.data.pliId;
    }

    this._methodEvaluationService
      .saveMethodEvaluation(this.data.transactionId, this.data.objectId, this.evaluation, this.data.isPba)
      .subscribe(() => {
        this.success();
        this.closeAllModals();
      });
  }

  private setEvaluationOfMethodTypesDropdownValues(): void {
    const { srcJurisdictionIsoCode, destJurisdictionIsoCode } = this.data;
    const [srcMethodEvaluations, destMethodEvaluations] = this._methodEvaluationService.getTransactionMethodEvaluations(srcJurisdictionIsoCode, destJurisdictionIsoCode);

    this.srcJurisdictionMethodEvaluations = srcMethodEvaluations;
    this.destJurisdictionMethodEvaluations = destMethodEvaluations;
  }
}
